import CMSection from '@src/components/Atoms/CMSection';
import { devices } from '@src/styles/theme';
import styled from 'styled-components';
import QuoteSvg from '@src/assets/imgs/sponser/quotes.svg';
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import { thanksLetters, thanksLettersMb } from '@src/data/sponser';
const ThanksLetter = () => {
  const sliderRef: any = useRef(null);
  const slidesRef: any = useRef(null);

  const [sliderWidth, setSliderWidths] = useState(0);
  const [slidesWidth, setSlidesWidths] = useState(0);

  const slideMarginRight = 15;
  const totalSlidesMarginRight = slideMarginRight * 6;
  const handleMouseDown = (e: any) => {
    e.preventDefault();
  };
  useEffect(() => {
    const measureSliderWidth = () => {
      setSliderWidths(sliderRef?.current?.clientWidth);
    };

    const measureSlidesWidth = () => {
      const slidesNode = slidesRef.current.childNodes;
      console.log(slidesNode, 'nomdeniode');

      const slidesArr = Array.from(slidesNode);
      const slidesSumWidth: any = slidesArr.reduce(
        (acc, node: any) => acc + node.clientWidth,
        0
      );
      setSlidesWidths(slidesSumWidth);
    };

    measureSliderWidth();
    measureSlidesWidth();

    window.addEventListener('resize', measureSliderWidth);
    window.addEventListener('resize', measureSlidesWidth);

    return () => {
      window.removeEventListener('resize', measureSliderWidth);
      window.removeEventListener('resize', measureSlidesWidth);
    };
  }, [sliderWidth, slidesWidth]);
  return (
    <CMSection
      background="var(--Gradation, linear-gradient(109deg, #FF6969 -3.19%, #F33 109.95%));"
      opacity="0.85"
    >
      <Wrap>
        <Flex>
          <QuoteIcon />
          <PcBigTitle>덕분에 어머니가 쾌유할 수 있었습니다</PcBigTitle>
          <MbBigTitle>
            덕분에 어머니가
            <br /> 쾌유할 수 있었습니다
          </MbBigTitle>
          <QuoteReverseIcon />
        </Flex>
        <PcSubTitle>
          피플에서 실제로 도움을 받고 작성해주신 감사메세지입니다
        </PcSubTitle>
        <MbSubTitle>
          피플에서 실제로 도움을 받고 작성해주신
          <br /> 감사메세지입니다
        </MbSubTitle>
        <ImageWrap ref={sliderRef}>
          <Ul
            ref={slidesRef}
            drag="x"
            dragConstraints={{
              left: -(slidesWidth - sliderWidth + totalSlidesMarginRight),
              right: 0,
            }}
            dragElastic={0.2}
            dragTransition={{ bounceDamping: 18 }}
          >
            {thanksLetters.map((imageSrc) => (
              <li>
                <Image
                  src={imageSrc}
                  onMouseDown={handleMouseDown}
                  onTouchStart={handleMouseDown}
                  alt={'dd'}
                  width={546}
                  height={233}
                />
              </li>
            ))}
          </Ul>
        </ImageWrap>
        {/* <ImageMbWrap ref={sliderRef}>
          <Ul
            ref={slidesRef}
            drag="x"
            dragConstraints={{
              left: -(slidesWidth - sliderWidth + totalSlidesMarginRight),
              right: 0,
            }}
            dragElastic={0.2}
            dragTransition={{ bounceDamping: 18 }}
          >
            {thanksLettersMb.map((imageSrc) => (
              <li>
                <img
                  src={imageSrc}
                  onMouseDown={handleMouseDown}
                  onTouchStart={handleMouseDown}
                />
              </li>
            ))}
          </Ul>
        </ImageMbWrap> */}
      </Wrap>
    </CMSection>
  );
};

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
  padding: 110px 0;

  @media ${devices.tablet} {
    padding: 50px 24px;
    gap: 30px;
  }
`;
const QuoteIcon = styled(QuoteSvg)`
  width: 70px;
  height: 60px;

  @media ${devices.tablet} {
    width: 28px;
    height: 24px;
  }
`;
const QuoteReverseIcon = styled(QuoteSvg)`
  transform: rotate(180deg);
  width: 70px;
  height: 60px;

  @media ${devices.tablet} {
    width: 28px;
    height: 24px;
  }
`;
const Flex = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 28px;

  @media ${devices.tablet} {
    gap: 4px;
  }
`;

const PcBigTitle = styled.div`
  color: ${({ theme }) => theme.commonColor.white};
  text-align: center;
  font-family: 'NOTO';
  font-size: 47px;
  font-style: normal;
  font-weight: 500;
  line-height: 65px; /* 138.298% */
  letter-spacing: -1.41px;
  white-space: pre-wrap;
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const MbBigTitle = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    white-space: pre-wrap;
    color: ${({ theme }) => theme.commonColor.white};
    text-align: center;
    font-family: 'NOTO';
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 36px; /* 150% */
    letter-spacing: -0.72px;
  }
`;

const PcSubTitle = styled.div`
  color: ${({ theme }) => theme.commonColor.white};
  text-align: center;
  font-family: 'Var';
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 40px; /* 153.846% */
  margin: 30px 0;
  display: block;
  @media ${devices.tablet} {
    display: none;
  }
`;

const MbSubTitle = styled.div`
  display: none;
  @media ${devices.tablet} {
    display: block;
    color: ${({ theme }) => theme.commonColor.white};
    text-align: center;
    font-family: 'Var';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
  }
`;

const ImageWrap = styled.div`
  max-width: 100vw;
  margin: 25px;
  display: flex;
  overflow-x: hidden;
  transition: 0.4s ease-out transform;

  &:active {
    transform: scale(0.95);
  }

  @media ${devices.tablet} {
    /* display: none; */
    img {
      width: 255px;
      height: 120px;
    }
  }
`;

const ImageMbWrap = styled.div`
  display: none;
  @media ${devices.tablet} {
    max-width: 100vw;
    margin: 25px;
    display: flex;
    overflow-x: hidden;
    transition: 0.4s ease-out transform;

    &:active {
      transform: scale(0.95);
    }
  }
`;

const Ul = styled(motion.ul)`
  display: flex;
  list-style: none;
  will-change: transform;
  flex-wrap: nowrap;
  &:hover {
    cursor: grab;
  }

  &:active {
    cursor: grabbing;
  }

  li {
    &:not(:last-of-type) {
      margin-right: 15px;
    }
  }
`;

export default ThanksLetter;
